var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticStyle: { overflow: "hidden" } },
    [
      _vm.supportsRefresh
        ? _c(
            "v-toolbar",
            { attrs: { flat: "", dense: "", color: "secondary", dark: "" } },
            [
              _c("v-toolbar-title", { staticClass: "body-2" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.dateRangeEditable
                ? _c(
                    "v-btn-toggle",
                    {
                      staticClass: "date-range-toggle",
                      attrs: { mandatory: "" },
                      on: { change: _vm.onDateRangeChange },
                      model: {
                        value: _vm.selectedDateRange,
                        callback: function ($$v) {
                          _vm.selectedDateRange = $$v
                        },
                        expression: "selectedDateRange",
                      },
                    },
                    _vm._l(_vm.dateRangeShortcuts, function (item, idx) {
                      return _c(
                        "v-btn",
                        {
                          key: idx,
                          staticClass: "text-capitalize",
                          attrs: {
                            flat: "",
                            small: "",
                            value: item.value,
                            title: item.label,
                          },
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(item.shortLabel) + "\n      "
                          ),
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.statisticalSummary.length
        ? _c(
            "div",
            { staticClass: "px-3 pt-2" },
            _vm._l(_vm.statisticalSummary, function (line, i) {
              return _c("div", { key: i, staticClass: "body-2 summary-line" }, [
                _vm._v(_vm._s(line)),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("v-progress-linear", {
            staticClass: "my-0",
            attrs: { indeterminate: "", color: "blue" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c(
            "v-alert",
            {
              staticClass: "py-1 ma-0",
              attrs: {
                outline: "",
                color: "warning",
                icon: "assessment",
                value: true,
              },
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.errorMessage)),
              ]),
            ]
          )
        : _c("div", { attrs: { id: _vm.graphDivId } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }